import styled from "styled-components";

export const DeletedPatientDiv = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const DeletedPatientText = styled.p`
  font-size: 22px;
  font-weight: bold;
  color: #808080;
`;
